import Prism from 'prismjs';
import 'prismjs/plugins/toolbar/prism-toolbar.js';
import 'prismjs/plugins/copy-to-clipboard/prism-copy-to-clipboard.js';

require('prismjs/components/prism-markup-templating');
require('prismjs/components/prism-json');
require('prismjs/components/prism-bash');
require('prismjs/components/prism-javascript');
require('prismjs/components/prism-ruby');
require('prismjs/components/prism-php');
require('prismjs/components/prism-go');
require('prismjs/components/prism-csharp');
require('prismjs/components/prism-python');
require('prismjs/components/prism-java');

var HTTPSnippet = require('httpsnippet'),
    json = null,
    url = $("#url-playground").val(),
    alert = $(".alert"),
    $loader = $("#loader-result"),
    $jsonResult = $("#json-renderer"),
    headers = $("input[name='headers']").val(),
    method = $("input[name='method']:checked").val() ?? "GET",
    urlParameters = {},
    initial_url_parameters = {},
    initial_url_playground = $("#url-playground").val() ?? "";

var initial_url_playground_query_entries = new URLSearchParams(initial_url_playground.split("?")[1]).entries();
for (var entry of initial_url_playground_query_entries) {
    urlParameters[entry[0]] = entry[1];
}
initial_url_parameters = Object.assign({}, urlParameters);
initial_url_playground = initial_url_playground.split("?")[0];

if (typeof(headers) !== 'undefined' && headers.length == 0) {
    headers = JSON.stringify([]);
}

$(document).ready(function(){
    if (typeof playgroundPage !== 'undefined' && playgroundPage) {
        if (typeof(headers) !== 'undefined') {
            require('./headers');
        }
        // Set Code Sample First
        if (url) {
            generateCode("curl", url);
        }
    
        $("input[name='headers']").on('change', function(){
            headers = $(this).val();
            var code = $("#code-sample").find(".tab-title.active").attr("id");
            generateCode(code, url);
        })

        $("input[name='method']").on('change', function(){
            method = $("input[name='method']:checked").val() ?? "GET";
            var code = $("#code-sample").find(".tab-title.active").attr("id");
            generateCode(code, url);
        })
    
        // Click Request API
        $(".btn-submit-playground").click(function(){
            if (typeof analytics !== 'undefined') {
                analytics.track("API Playground", {
                    userId: logged_in_user.id,
                    label: 'event',
                });
            }
            $.ajax({
                type: method,
                url: url,
                headers: {Accept: "application/json"},
                beforeSend: function() {
                    $("#result-tab").click();
                    showLoader();
                    hideAlert();
                    hideResult();
                },
                error: function(xhr, status, error) {
                    try {
                        error = JSON.parse(xhr.responseText);
                        if (error.hasOwnProperty('error')) {
                            error.error = error.error.replace('upgrade', '<a href="/plans">upgrade</a>');
                            alert.find(".messages").html(error.error);
                            showAlert();
                            hideLoader();
                            showResult();
                        } else {
                            json = JSON.stringify({
                                response: xhr.responseText,
                                error: error,
                                status: status
                            }, null, '\t');
                            hideAlert();
                            hideLoader();
                            showResult();
                            dataResult();
                        }
                    } catch(e) {
                        json = JSON.stringify({
                            response: xhr.responseText,
                            error: error,
                            message: 'API Response JSON was not parsed correctly',
                            status: status
                        }, null, '\t');
                        hideAlert();
                        hideLoader();
                        showResult();
                        dataResult();
                    }
                },
                success: function(data){
                    json = data;
                    if (typeof json == "object") {
                        json = JSON.stringify(json, null, '\t')
                    }
                    hideAlert();
                    hideLoader();
                    showResult();
                    dataResult();
                }
            });
        });
    
        setTimeout(() => {
            $("#engine")[0].dispatchEvent(new Event("change"));
        }, 100);

        // Event Change Input/Select
        $(".playground-parameters").change(function(){
            var value = $(this).val();
            var name  = $(this).attr("name");
            var type  = $(this).attr("type");
            var ignore = $(this).attr("data-ignore");
            var multiple = $(this).attr("multiple");
            var valid = false;
            if (!isEmpty(value)) {
                valid = true;
                if (name == "url" && !isUrl(value)) valid = false;
            }

            if (valid && (name == "url" || name == "cookie")) {
                value = encodeURIComponent(value);
            }

            if (valid && (name =="time_period_min" || name == "time_period_max")) {
                value = new Date(value);
                var month = value.getMonth() + 1;
                if (month < 10) {
                    month = "0" + month;
                }
                var day = value.getDate();
                if (day < 10) {
                    day = "0" + day;
                }
                var year = value.getFullYear();
                value = month + '/' + day + '/' + year;
            }

            if (typeof multiple !== 'undefined' && multiple !== false && value) {
                value = value.join("|");
            }

            if (type == "radio") {
                if (!$(this).is(":checked")) {
                    return;
                }
            }

            if (name == "engine") {
                urlParameters = Object.assign({}, initial_url_parameters);
                $("." + value + "-parameters").not("[name='engine']").each(function(){
                    $(this)[0].dispatchEvent(new Event("change"));
                })
            }

            if (ignore == "true") {
                valid = false;
            }

            if (valid) setUrl(name, value, "add");
            if (!valid) setUrl(name, value, "remove");
        });

        $("#googleScholarQuery, #googleScholarCites").on('change', function(){
            if ($("#googleScholarQuery").val().length > 0 || $("#googleScholarCites").val().length > 0) {
                $("#googleSholarCluster input").each(function(){
                    $(this).val("");
                    $(this)[0].dispatchEvent(new Event("change"));
                })
                $("#googleSholarCluster").hide();
            } else {
                $("#googleSholarCluster").show();
            }
        })

        $("#timePeriod").on('change', function(){
            if ($(this).val() == "custom") {
                $("#timePeriodRow").show();
            } else {
                $("#timePeriodRow input").each(function(){
                    $(this).val("");
                    $(this)[0].dispatchEvent(new Event("change"));
                })
                $("#timePeriodRow").hide();
            }
        })

        $("#tbm").on('change', function(){
            if ($(this).val() == "isch") {
                $("#ijnRow").show();
            } else {
                $("#ijnRow").hide();
                $("#ijnRow").find("input").first().val("");
                $("#ijnRow").find("input").first()[0].dispatchEvent(new Event("change"));
            }
        })

        $("#yandexDomain").on('change', function(){
            if ($(this).val() == "yandex.ru" || $(this).val() == "yandex.com.tr") {
                $("#yandexLr").show();
            } else {
                $("#yandexLr").hide();
                $("#yandexLr").find("select").first().val("");
                $("#yandexLr").find("select").first()[0].dispatchEvent(new Event("change"));
            }
        })

        $("#amazonType").on('change', function(){
            $("#amazonQuery").hide();
            $("#amazonQuery").find("input").first().val("");
            $("#amazonQuery").find("input").first()[0].dispatchEvent(new Event("change"));
            $("#amazonProductId").hide();
            $("#amazonProductId").find("input").first().val("");
            $("#amazonProductId").find("input").first()[0].dispatchEvent(new Event("change"));
            $("#amazonCategoryId").hide();
            $("#amazonCategoryId").find("input").first().val("");
            $("#amazonCategoryId").find("input").first()[0].dispatchEvent(new Event("change"));
            $("#amazonParentAlias").hide();
            $("#amazonParentAlias").find("input").first().val("");
            $("#amazonParentAlias").find("input").first()[0].dispatchEvent(new Event("change"));
            $("#amazonPage").hide();
            $("#amazonPage").find("input").first().val("");
            $("#amazonPage").find("input").first()[0].dispatchEvent(new Event("change"));
            $("#amazonSortBy").hide();
            $("#amazonSortBy").find("select").first().val("");
            $("#amazonSortBy").find("select").first()[0].dispatchEvent(new Event("change"));
            if ($(this).val() == "search") {
                $("#amazonQuery").show();
                $("#amazonPage").show();
                $("#amazonSortBy").show();
            } else if ($(this).val() == "product") {
                $("#amazonProductId").show();
            } else {
                $("#amazonCategoryId").show();
                if ($(this).val() == "bestsellers" || $(this).val() == "new-releases") {
                    $("#amazonParentAlias").show();
                }
            }
        })

        $("#amazonDomain").on('change', function() {
            if ($(this).val()) {
                $("#amazonHl option:not(.no-value)").hide();
                const className = $(this).val().replace(/\./g, '-');
                $("#amazonHl ." + className).show();
                $("#amazonHl").val("");
                $("#amazonHl")[0].dispatchEvent(new Event("change"));
            } else {
                $("#amazonHl option").show();
                $("#amazonHl").val("");
                $("#amazonHl")[0].dispatchEvent(new Event("change"));
            }
        })

        $(".category-id-autocomplete").autocomplete({
            source: function(request, response) {
                fetch("https://amazon-helpers.searchdata.io/categories?limit=20&q=" + request.term, {
                    method: 'GET',
                })
                .then(response => response.text())
                .then(result => { 
                    result = JSON.parse(result);
                    response($.map(result, function (item) {
                        return {
                            label: item['title'],
                            value: JSON.stringify(item),
                        };
                    }));
                })
            },
            select: function(event, ui) {
                event.preventDefault();
                $(this).val(ui.item.label);
                let category_id = JSON.parse(ui.item.value).category_id;
                let alias = JSON.parse(ui.item.value).parent_alias;
                $(this).prev(".category-id-value").val(encodeURIComponent(category_id));
                $(this).prev(".category-id-value")[0].dispatchEvent(new Event("change"));
                $("#amazonAlias").val(alias);
                $("#amazonAlias")[0].dispatchEvent(new Event("change"));
            },
        });

        $(".category-id-autocomplete").on('change', function(){
            if ($(this).val() == "") {
                $(this).prev(".category-id-value").val("");
                $(this).prev(".category-id-value")[0].dispatchEvent(new Event("change"));
            }
        })

        $(".location-autocomplete").autocomplete({
            source: function(request, response) {
                fetch("https://locations.searchdata.io/?limit=10&q=" + request.term, {
                    method: 'GET',
                })
                .then(response => response.text())
                .then(result => { 
                    result = JSON.parse(result);
                    response($.map(result, function (item) {
                        return {
                            label: item['Canonical Name'],
                            value: '"' + item['Criteria ID'] + '","' + 
                                        item['Name'] + '","' + 
                                        item['Canonical Name'] + '","' + 
                                        item['Parent ID'] + '","' + 
                                        item['Country Code'] + '","' + 
                                        item['Target Type'] + '",' + item['Status'],
                        };
                    }));
                })
            },
            select: function(event, ui) {
                event.preventDefault();
                $(this).val(ui.item.label);
                $(this).prev(".location-value").val(encodeURIComponent(ui.item.value));
                $(this).prev(".location-value")[0].dispatchEvent(new Event("change"));
            },
        });

        $(".location-autocomplete").on('change', function(){
            if ($(this).val() == "") {
                $(this).prev(".location-value").val("");
                $(this).prev(".location-value")[0].dispatchEvent(new Event("change"));
            }
        })

        $(".playground-parameters").each(function(){
            $(this)[0].dispatchEvent(new Event("change"));
        })
    
        // Event Click Language title
        $(".tab-title").click(function(){
            var code = $(this).attr("id");
            if (url != "") generateCode(code, url);
        });

        $(".options input").on('click', function(){
            var options = $(this).parent().parent().find("label");
            options.each(function(){
                $(this).removeClass("active");
            })
            if ($(this).is(":checked")) {
                $(this).parent().addClass("active");
            }
        })
    }
})

// Ajax Get Country
function getCountryByType(value)
{
    return $.ajax({
        type: "GET",
        url: 'api/playground/countries',
        headers: {
            'Authorization': 'Bearer ' + logged_in_user.api_token,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        data: {type: value},
    });
}

// Get Response Ajax Country
async function getResponseCountryByType(value)
{
    try {
        var response = await getCountryByType(value);
        var result = null;
        if(response){
            result = $.map(response, function (item, key) {
                return {
                    text: item,
                    id: key
                }
            });
            $('.country').empty().select2({data: result});
        }

    } catch (error) {
        console.log(error);
    } 
}

// Check if url
function isUrl(value) {
    value = value.replace(" ", ""); // We can have spaces in url's so we remove them vor the validation only
    return /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(value);
}

// Check if empty
function isEmpty(str) {
    return (!str || 0 === str.length);
}

// Set Url API
function setUrl(name, value, type = "add") {
    if (type == "add") {
        urlParameters[name] = value;
    }

    if (type == "remove") {
        delete urlParameters[name];
    }

    var queryString = Object.keys(urlParameters).map(key => key + '=' + urlParameters[key]).join('&');
    url = initial_url_playground + "?" + queryString;

    var code = $("#code-sample").find(".tab-title.active").attr("id");
    
    generateCode(code, url);
    $("#url-playground").val(url);
}

// Function for replace parameter
function replaceUrlParam(url, paramName, paramValue) {
    var pattern = new RegExp('\\b('+paramName+'=).*?(&|#|$)');

    if (paramValue == null) paramValue = '';
    if (url.search(pattern) >= 0) return url.replace(pattern,'$1' + paramValue + '$2');

    url = url.replace(/[?#]$/,'');

    return url + (url.indexOf('?')>0 ? '&' : '?') + paramName + '=' + paramValue;
}

// Funciton for remove parameter
function removeParam(key, sourceURL) {
    var rtn = sourceURL.split("?")[0],
        param,
        params_arr = [],
        queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";
    if (queryString !== "") {
        params_arr = queryString.split("&");
        for (var i = params_arr.length - 1; i >= 0; i -= 1) {
            param = params_arr[i].split("=")[0];
            if (param === key) {
                params_arr.splice(i, 1);
            }
        }
        rtn = rtn + "?" + params_arr.join("&");
    }
    return rtn;
}

function showAlert() {
    alert.removeClass("d-none");
    alert.addClass("d-block");
}

function hideAlert() {
    alert.addClass("d-none");
    alert.removeClass("d-block");
}

function showLoader() {
    $loader.show();
}

function hideLoader() {
    $loader.hide();
}

function showResult() {
    $jsonResult.show();
    $("#result").find('button').show();
}

function hideResult() {
    $jsonResult.hide();
    $("#result").find('button').hide();
}

// Function to generate JSON to other lang
function generateCode(code, url) {
    var snippet = new HTTPSnippet({
        method: method,
        headers: parseHeaders(headers),
        url: url
    });
    var typeLanguage = typeCode(code, {indent: '\t'});
    var codeSnippet = snippet.convert(typeLanguage.lang, typeLanguage.options);
    if (typeLanguage.lang == "shell") {
        codeSnippet = codeSnippet.replaceAll("'", '"');
    }
    $("#code-" + code).html(Prism.highlight(codeSnippet, typeLanguage.prism));
    $(".code-toolbar button").each(function(){
        $(this).addClass("btn btn-primary");
        var copyCodeText = $(this).text();
        $(this).on('click', function(){
            $(this).text(copyCodeText);
        })
    })
}

// Show result in tab result
function dataResult() {
    $('#json-renderer').find("code").text(json);
}

// Checking type of language
function typeCode(code) {
    var lang = "";
    var variant = "";
    var prism = null;
    var options = {};

    switch(code) {
        case "nodejs":
            lang = "node"
            variant = "axios"
            prism = Prism.languages.javascript
            break;
        case "python":
            lang = "python"
            variant = "http.client"
            prism = Prism.languages.python
            break;
        case "php":
            lang = "php"
            variant = "cURL"
            prism = Prism.languages.php
            break;
        case "golang":
            lang = "go"
            variant = "native"
            prism = Prism.languages.go
            break;
        case "java":
            lang = "java"
            variant = "OkHttp"
            prism = Prism.languages.java
            break;
        case "dotnet":
            lang = "csharp"
            variant = "RestSharp"
            prism = Prism.languages.csharp
            break;
        case "ruby":
            lang = "ruby"
            variant = "Net::HTTP"
            prism = Prism.languages.ruby
            break;
        default:
            lang = "shell"
            variant = "curl"
            prism = Prism.languages.bash
            options = {
                indent: false
            }
    }

    return {lang, variant, prism, options}
}

function parseHeaders(headers) {
    try {
        var headersObj = JSON.parse(headers);
        var result = [];
        for (var key in headersObj) {
            result.push({
                "name": key,
                "value": headersObj[key],
                "comment": ""
            });
        }
        return result;
    } catch (e) {
        return "";
    }
}